import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ImagibleItem from "../ImagibleItem/ImagibleItem";
import { ENV } from '../../../config/config';
import Masonry from "react-masonry-component";
import { beforeExplore, getExplore, beforeId, beforeAll } from './ImagibleItems.action'
import { connect } from 'react-redux';
import Shuffle from 'shufflejs';
import FullPageLoader from "../../../components/full-page-loader/full-page-loader";

const ImagibleItems = forwardRef((props, ref) => {
  const [nfts, setNfts] = useState(null)
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [catPage, setCatPage] = useState(2)
  const [catId, setCatId] = useState(null)
  const [shuffleInstance, setShuffle] = useState(null)
  const [loader, setLoader] = useState(true)
  // const [hasData, setHasData] = useState(false)

  useEffect(() => {
    window.scroll(0, 0)
    getExploreData()
  }, [])

  // useEffect(() => {
  //   if (!loader) {
  //     setTimeout(() => {
  //       let element = document.getElementById('grid')
  //       if (element) {
  //         const shuffleInstance = new Shuffle(element, {
  //           itemSelector: '.grid-item',
  //           // sizer: '.js-shuffle-sizer',
  //         });

  //         setShuffle(shuffleInstance)
  //       }
  //     }, 1000)
  //   }
  // }, [loader])

  useEffect(() => {
    if (props.explore.allAuth) {
      setData([])
      let qs = ENV.objectToQueryString({ page: 1 });
      props.getExplore(qs);
      setPage(2);
      setCatId(null);
      props.beforeAll();
    }
  }, [props.explore.allAuth])

  useEffect(() => {
    if (props.explore.nftsAuth) {
      const { nfts } = props.explore.nfts
      // setHasData(nfts?.length > 0 ? true : false)
      setNfts(nfts)
      if (props.filter)
        setData([...nfts])
      else
        setData([...data, ...nfts])
      props.beforeExplore()
      setLoader(false)
    }
  }, [props.explore.nftsAuth])

  useEffect(() => {
    if (props.explore.navAuth) {
      setData([])
      setCatPage(2)
      let qs = { page: 1 };
      setCatId(props.explore.catId)
      if (props.explore.catId)
        qs.categoryId = props.explore.catId
      qs = ENV.objectToQueryString(qs)
      props.getExplore(qs);
      props.beforeId()
    }
  }, [props.explore.navAuth])

  const getExploreData = (filter = {}) => {
    let qs = ENV.objectToQueryString({ page, ...filter });
    props.getExplore(qs);
    setPage(page + 1);
  }

  const loadButton = () => {
    if (nfts) {
      if (nfts.length >= 100 && data.length > 0) {
        return (
          <div className="text-center p-5">
            <button className="btn btn-bordered-white" type="button"
              onClick={(e) => {
                if (catId) {
                  let qs = { page: catPage }
                  if (catId)
                    qs.categoryId = catId
                  qs = ENV.objectToQueryString(qs);
                  props.getExplore(qs);
                  setCatPage(catPage + 1);
                }
                else {
                  getExploreData()
                }

              }}>
              Load More
            </button>
          </div>
        )
      }
    }
  }

  useImperativeHandle(ref, () => ({
    getCatNFTs: (categoryId) => {
      // if (shuffleInstance) {
      //   // console.log("shuffleInstanceshuffleInstanceshuffleInstanceshuffleInstance")
      //   // console.log(shuffleInstance)
      //   // shuffleInstance.filter(`cat-${categoryId}`);
      // }

      // check active category data
      if (categoryId && categoryId !== 1) {
        let catData = nfts.filter((elem) => elem.categoryId === categoryId)
        setData(catData)
      }
      else {
        setData(nfts)
      }

    }
  }))

  return (
    <>
      {loader && <FullPageLoader />}
      {
        data.length > 0 ?
          <Masonry id="grid" className="grid masonry-layout text-center" options={{
            transitionDuration: 500
          }}>
            {
              data.length > 0 &&
              data.map((item, index) => {
                return (
                  <ImagibleItem key={index} {...item} />
                )
              })
            }
          </Masonry>
          : <div className="no-data border">No NFT To Show.</div>
      }
      {loadButton()}
    </>
  );
})

const mapStateToProps = state => ({
  error: state.error,
  explore: state.explore
});

export default connect(mapStateToProps, { beforeExplore, getExplore, beforeId, beforeAll }, null, { forwardRef: true })(ImagibleItems);
